export const getAutomationTasksByCandidateBatchId = /* GraphQL */ `
  query GetAutomationTasksByCandidateBatchId(
    $candidateBatchId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAutomationTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAutomationTasksByCandidateBatchId(
      candidateBatchId: $candidateBatchId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requirementConditions {
          type
          operator
          candidateStatus
          scoreScaled
        }
        action {
          type
          campaignId
          candidateStatus
          atsRejectedReasonId
          atsInterviewStageId
          komboRejectionReasonId
          komboStageId
          includePersonalisation
          includeJobBoardLink
          jobBoardLink
        }
        candidateBatchId
        createdAt
        updatedAt
        parentAutomationTaskId
      }
      nextToken
    }
  }
`;

export const getAutomationTasksByCandidateBatchGroup = /* GraphQL */ `
  query GetAutomationTasksByCandidateBatchGroup(
    $candidateBatchGroupId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAutomationTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAutomationTasksByCandidateBatchGroup(
      candidateBatchGroupId: $candidateBatchGroupId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        candidateBatchId
        candidateBatchGroupId
        isParent
        parentAutomationTaskId
        campaignId
        createdAt
        updatedAt
        organizationId
        requirementConditions {
          type
          operator
          candidateStatus
          scoreScaled
        }
        action {
          type
          campaignId
          candidateStatus
          atsRejectedReasonId
          atsInterviewStageId
          komboRejectionReasonId
          komboStageId
          includePersonalisation
          includeJobBoardLink
          jobBoardLink
        }
      }
      nextToken
    }
  }
`;

export const getAutomationTasksByCampaignId = /* GraphQL */ `
  query GetAutomationTasksByCampaignId(
    $campaignId: ID!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAutomationTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAutomationTasksByCampaignId(
      campaignId: $campaignId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        requirementConditions {
          type
          conversationStatus
          documentTypes
        }
        action {
          type
          campaignId
          candidateStatus
          atsRejectedReasonId
          atsInterviewStageId
          komboRejectionReasonId
          komboStageId
          recipientEmailAddress
        }
        campaignId
        createdAt
        updatedAt
        organizationId
      }
      nextToken
      __typename
    }
  }
`;

export const getAutomationTaskEmailTemplatesByOrganization = /* GraphQL */ `
  query GetAutomationTaskEmailTemplatesByOrganization(
    $organizationId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAutomationTaskEmailTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getAutomationTaskEmailTemplatesByOrganization(
      organizationId: $organizationId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        defaultEmailTemplate
        emailTemplateWithPersonalisation
        emailTemplateWithJobBoardLink
        emailTemplateWithPersonalisationAndJobBoardLink
        jobRecommendationsEmailTemplate
        jobRecommendationsEmailTemplateWithJobBoardLink
        customEmailTemplate
        createdAt
        updatedAt
      }
    }
  }
`;
